import type { TranslationDictionary } from "../types";

export const fr: TranslationDictionary = {
  "menu.section.dashboard": "Dashboard",
  "menu.section.hr": "RH",
  "menu.section.workforce": "Employés & Organisation",
  "menu.section.attendance": "Présence",
  "menu.section.manager": "Mon équipe",
  "menu.section.payroll": "Paie",
  "menu.section.recruitment": "Recrutement",
  "menu.section.assets": "Assets",
  "menu.section.security": "Sécurité",
  "menu.section.itsm": "ITSM",
  "menu.section.msp": "MSP Operations",
  "menu.section.contracts": "MSP Commercial",
  "menu.section.serviceDelivery": "Service Delivery",
  "menu.section.crm": "CRM",
  "menu.section.support": "Support",
  "menu.section.administration": "Administration",
  "menu.section.tenants": "Tenants",
  "menu.section.platform": "Plateforme",
  "menu.section.languages": "Langues",
  "menu.item.dashboard": "Dashboard",
  "menu.item.tenantDashboard": "Tableau ITaaS",
  "menu.item.workforceHome": "Accueil Workforce",
  "menu.item.recruitmentHome": "Accueil Recruitment",
  "menu.item.attendanceHome": "Accueil Attendance",
  "menu.item.employees": "Employés",
  "menu.item.departments": "Départements",
  "menu.item.positions": "Postes",
  "menu.item.organization": "Organisation",
  "menu.item.organizationChart": "Organigramme",
  "menu.item.organizationDepartments": "Départements",
  "menu.item.organizationPositions": "Postes",
  "menu.item.organizationManagers": "Managers",
  "menu.item.actionValidationInbox": "Validations",
  "menu.item.actionValidationPolicies": "Policies validation",
  "menu.item.leavesSection": "Congés",
  "menu.item.leaveRequests": "Demandes",
  "menu.item.leaveBalances": "Soldes",
  "menu.item.leaveCalendar": "Calendrier",
  "menu.item.leaveApprovals": "Approbations",
  "menu.item.attendance": "Présences",
  "menu.item.attendanceSection": "Présence",
  "menu.item.attendanceRecords": "Présences",
  "menu.item.attendanceCalendar": "Calendrier",
  "menu.item.attendanceExceptions": "Exceptions",
  "menu.item.attendanceAnalytics": "Analytique",
  "menu.item.attendanceDiscrepancies": "Écarts",
  "menu.item.attendanceBiometricDevices": "Lecteurs biométriques",
  "menu.item.scheduleSection": "Horaires & Shifts",
  "menu.item.schedules": "Horaires",
  "menu.item.shifts": "Shifts",
  "menu.item.assignments": "Affectations",
  "menu.item.rotations": "Rotations",
  "menu.item.performanceSection": "Performance",
  "menu.item.performanceGoals": "Objectifs",
  "menu.item.performanceKPIs": "KPIs",
  "menu.item.performanceReviews": "Évaluations",
  "menu.item.performanceScores": "Scores",
  "menu.item.performanceSuggestions": "Suggestions",
  "menu.item.compensationSection": "Compensation",
  "menu.item.compensationDashboard": "Vue d'ensemble",
  "menu.item.compensationBonuses": "Primes",
  "menu.item.compensationAdjustments": "Ajustements",
  "menu.item.compensationRules": "Règles",
  "menu.item.trainingSection": "Training & Learning",
  "menu.item.trainingDashboard": "Vue d'ensemble",
  "menu.item.trainingCourses": "Cours",
  "menu.item.trainingAssignments": "Affectations",
  "menu.item.trainingCertifications": "Certifications",
  "menu.item.careerSection": "Career & Succession",
  "menu.item.careerDashboard": "Vue d'ensemble",
  "menu.item.careerPaths": "Parcours",
  "menu.item.careerPromotions": "Promotion Readiness",
  "menu.item.careerSuccession": "Succession",
  "menu.item.careerGoals": "Objectifs",
  "menu.item.recruitmentSection": "Recruitment",
  "menu.item.recruitmentDashboard": "Vue d'ensemble",
  "menu.item.recruitmentJobs": "Offres",
  "menu.item.recruitmentCandidates": "Candidats",
  "menu.item.recruitmentInterviews": "Entretiens",
  "menu.item.recruitmentPipeline": "Pipeline",
  "menu.item.recruitmentTalentPool": "Vivier & recalés",
  "menu.item.recruitmentEmailImport": "Import email",
  "menu.item.assetsSection": "Assets",
  "menu.item.assetsDashboard": "Vue d'ensemble",
  "menu.item.assetsInventory": "Inventaire",
  "menu.item.assetsAssignments": "Affectations",
  "menu.item.assetsMaintenance": "Maintenance",
  "menu.item.assetsLifecycle": "Lifecycle",
  "menu.section.inventory": "Inventaire",
  "menu.section.inventoryOverview": "Vue d'ensemble",
  "menu.section.inventoryOrganization": "Organisation",
  "menu.section.inventoryCatalog": "Catalogue",
  "menu.section.inventoryLogistics": "Logistique",
  "menu.section.inventoryStock": "Stock & mouvements",
  "menu.section.inventoryIntegrations": "Intégrations",
  "menu.section.inventoryAdmin": "Administration",
  "menu.item.inventoryDashboard": "Tableau de bord",
  "menu.item.inventoryArticles": "Articles",
  "menu.item.inventoryOrganization": "Organisation",
  "menu.item.inventoryCategories": "Catégories",
  "menu.item.inventoryBrands": "Marques",
  "menu.item.inventoryUnits": "Unités",
  "menu.item.inventoryWarehouses": "Entrepôts",
  "menu.item.inventoryLocations": "Zones & emplacements",
  "menu.item.inventoryStockBalance": "Niveaux de stock",
  "menu.item.inventoryMovements": "Journal des mouvements",
  "menu.item.inventoryReceipts": "Réceptions",
  "menu.item.inventoryIssues": "Sorties",
  "menu.item.inventoryTransfers": "Transferts",
  "menu.item.inventoryAdjustments": "Ajustements",
  "menu.item.inventoryReturns": "Retours",
  "menu.item.inventoryReconciliation": "Réconciliation",
  "menu.item.inventoryWebhooks": "Webhooks",
  "menu.item.inventoryBarcode": "Scan & code-barres",
  "menu.item.inventoryStockLabels": "Étiquetage stock",
  "menu.item.inventoryDevices": "Lecteurs & terminaux",
  "menu.item.inventoryLabelPrinting": "Impression étiquettes",
  "menu.item.inventoryAudit": "Journal d'audit",
  "menu.item.inventoryNotifications": "Notifications",
  "menu.item.inventorySettings": "Paramètres",
  "menu.section.product": "Catalogue produit",
  "menu.item.productDashboard": "Tableau de bord",
  "menu.item.productProducts": "Produits",
  "menu.item.productCategories": "Catégories",
  "menu.item.productBrands": "Marques",
  "menu.item.productUnits": "Unités",
  "menu.item.productTags": "Tags",
  "menu.section.productCommercial": "Commercial",
  "menu.item.productPricing": "Grilles tarifaires",
  "menu.item.productTaxes": "Taxes",
  "menu.section.productPartners": "Partenaires",
  "menu.item.productSuppliers": "Fournisseurs",
  "menu.item.productManufacturers": "Fabricants",
  "menu.section.productData": "Données",
  "menu.item.productImports": "Import",
  "menu.item.productExports": "Export",
  "menu.item.productSearch": "Recherche",
  "menu.section.productIntegrations": "Intégrations",
  "menu.item.productApiKeys": "Clés API",
  "menu.item.productWebhooks": "Webhooks",
  "menu.section.productAdmin": "Administration",
  "menu.item.productNotifications": "Notifications",
  "menu.item.productRevisions": "Versions",
  "menu.item.productClassification": "Classification IA",
  "menu.item.productDedup": "Déduplication",
  "menu.item.productSettings": "Paramètres",
  "menu.item.securitySection": "Sécurité",
  "menu.item.securityDashboard": "Vue d'ensemble",
  "menu.item.securityAgents": "Agents",
  "menu.item.securityGrades": "Grades",
  "menu.item.securityDocuments": "Documents",
  "menu.item.securityCertifications": "Certifications",
  "menu.item.securitySettings": "Paramètres",
  "menu.section.securityOperations": "Opérations",
  "menu.section.securityWorkforce": "Effectifs",
  "menu.section.securityAttendance": "Présence terrain",
  "menu.section.securityPatrols": "Rondes",
  "menu.section.securityIncidents": "Incidents",
  "menu.section.securityLogbook": "Main courante",
  "menu.section.securityAccess": "Contrôle d'accès",
  "menu.section.securityEquipment": "Équipements",
  "menu.section.securityAdmin": "Administration",
  "menu.item.securityClients": "Clients",
  "menu.item.securitySites": "Sites",
  "menu.item.securityPosts": "Postes",
  "menu.item.securityAssignments": "Affectations",
  "menu.item.securityShifts": "Shifts",
  "menu.item.securityQualifications": "Qualifications",
  "menu.item.securityCheckIn": "Pointage entrée",
  "menu.item.securityCheckOut": "Pointage sortie",
  "menu.item.securityPresence": "Présence",
  "menu.item.securityPatrolRoutes": "Itinéraires",
  "menu.item.securityCheckpoints": "Points de contrôle",
  "menu.item.securityPatrolExecutions": "Exécutions",
  "menu.item.securityIncidents": "Incidents",
  "menu.item.securityInvestigations": "Enquêtes",
  "menu.item.securityIncidentActions": "Actions",
  "menu.item.securityLogEntries": "Entrées",
  "menu.item.securityLogEvents": "Événements",
  "menu.item.securityLogObservations": "Observations",
  "menu.item.securityVisitors": "Visiteurs",
  "menu.item.securityVehicles": "Véhicules",
  "menu.item.securityPasses": "Badges",
  "menu.item.securityEquipmentAssignments": "Dotations",
  "menu.item.securityWeapons": "Armes",
  "menu.item.securityRadios": "Radios",
  "menu.item.securityUniforms": "Uniformes",
  "menu.item.securityWorkflows": "Workflows",
  "menu.item.securityReports": "Rapports",
  "menu.item.itsmSection": "ITSM",
  "menu.item.itsmDashboard": "Vue d'ensemble",
  "menu.item.itsmTickets": "Tickets",
  "menu.item.itsmIncidents": "Incidents",
  "menu.item.itsmSla": "SLA",
  "menu.item.itsmTechnicians": "Technicians",
  "menu.item.mspSection": "MSP Operations",
  "menu.item.mspDashboard": "Vue d'ensemble",
  "menu.item.mspProblems": "Problems",
  "menu.item.mspChanges": "Changes",
  "menu.item.mspProjects": "Projects",
  "menu.item.mspKnowledge": "Knowledge Base",
  "menu.item.contractsSection": "MSP Commercial",
  "menu.item.contractsDashboard": "Vue d'ensemble",
  "menu.item.contractsCustomers": "Customers",
  "menu.item.contractsList": "Contracts",
  "menu.item.contractsServices": "Service Catalog",
  "menu.item.contractsBilling": "Billing",
  "menu.item.serviceDeliverySection": "Service Delivery",
  "menu.item.serviceDeliveryDashboard": "Dashboard",
  "menu.item.serviceDeliveryRequests": "Demandes",
  "menu.item.serviceDeliveryApprovals": "Approbations",
  "menu.item.serviceDeliveryProvisioning": "Provisioning",
  "menu.item.serviceDeliveryAutomation": "Automation",
  "menu.item.serviceDeliveryTemplates": "Modèles",
  "menu.item.leaves": "Congés",
  "menu.item.payslips": "Bulletins",
  "menu.item.payrollRuns": "Exécutions de paie",
  "menu.item.payrollSection": "Paie",
  "menu.item.jobs": "Offres",
  "menu.item.candidates": "Candidats",
  "menu.item.contacts": "Contacts",
  "menu.item.companies": "Entreprises",
  "menu.item.deals": "Opportunités",
  "menu.item.leads": "Leads",
  "menu.item.tickets": "Tickets",
  "menu.item.knowledgebase": "Base de connaissances",
  "menu.item.users": "Utilisateurs",
  "menu.item.tenantUsers": "Utilisateurs",
  "menu.item.roles": "Rôles",
  "menu.item.tenantRoles": "Rôles",
  "menu.item.tenantModuleAccess": "Accès modules",
  "menu.item.tenantSites": "Sites & stocks",
  "menu.item.tenantProvisioning": "Provisionnement",
  "menu.item.invitations": "Invitations",
  "menu.item.settings": "Paramètres",
  "menu.item.tenantCompanies": "Entreprises",
  "menu.item.subscriptions": "Abonnements",
  "menu.item.domains": "Domaines",
  "menu.item.clientTickets": "Tickets clients",
  "menu.item.sla": "SLA",
  "menu.item.platformSettings": "Paramètres plateforme",
  "menu.item.packages": "Packages",
  "menu.item.languageFrench": "Français",
  "menu.item.languageEnglish": "Anglais",
  "common.searchInApp": "Rechercher dans {app}",
  "common.language.fr": "FR",
  "common.language.en": "EN",
};
